const Wishlist = {
  KEY: 'ct-wishlist',

  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); }
    catch { return []; }
  },

  save(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
    this.updateBadge();
  },

  has(id) {
    return this.get().some(p => p.id === id);
  },

  add(product) {
    const items = this.get();
    if (!items.some(p => p.id === product.id)) {
      items.push(product);
      this.save(items);
    }
    this.toast('Ajouté aux favoris');
    this.syncButtons(product.id);
  },

  remove(id) {
    this.save(this.get().filter(p => p.id !== id));
    this.toast('Retiré des favoris');
    this.syncButtons(id);
    if (document.querySelector('.ct-wishlist-page')) this.renderPage();
  },

  toggle(product) {
    if (this.has(product.id)) {
      this.remove(product.id);
    } else {
      this.add(product);
    }
  },

  updateBadge() {
    const count = this.get().length;
    document.querySelectorAll('.ct-wishlist-badge').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  syncButtons(id) {
    const active = this.has(id);
    document.querySelectorAll(`[data-wishlist-id="${id}"]`).forEach(btn => {
      btn.classList.toggle('ct-wish-active', active);
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  },

  syncAll() {
    document.querySelectorAll('[data-wishlist-id]').forEach(btn => {
      const id = parseInt(btn.dataset.wishlistId);
      btn.classList.toggle('ct-wish-active', this.has(id));
    });
    this.updateBadge();
  },

  toast(msg) {
    let el = document.getElementById('ct-wish-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ct-wish-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('ct-wish-toast--visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('ct-wish-toast--visible'), 2200);
  },

  formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' MAD';
  },

  async addToCart(variantId, productUrl, btn) {
    const textEl = btn.querySelector('.ct-pf-btn-text');
    const originalText = textEl ? textEl.textContent.trim() : btn.textContent.trim();
    btn.classList.add('ct-loading');
    btn.disabled = true;

    try {
      let vid = variantId;

      // Variant manquant → récupérer via l'API produit
      if (!vid) {
        const productRes = await fetch(productUrl + '.js');
        if (!productRes.ok) throw new Error('product fetch failed');
        const productData = await productRes.json();
        const available = productData.variants.find(v => v.available) || productData.variants[0];
        vid = available ? String(available.id) : null;
      }
      if (!vid) throw new Error('no variant');

      // Sections attendues par cart-notification du thème (lues depuis le code source)
      const SECTIONS = [
        'cart-notification-product',
        'cart-notification-price',
        'cart-notification-button',
        'cart-icon-bubble'
      ];

      // Format single-item (retourne { key, sections, ... }) requis par renderContents
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: parseInt(vid),
          quantity: 1,
          sections: SECTIONS,
          sections_url: window.location.pathname
        })
      });

      if (!res.ok) throw new Error('add failed');
      const parsedState = await res.json();

      // Mettre à jour le compteur badge en arrière-plan
      fetch('/cart.js').then(r => r.json()).then(cartData => {
        document.querySelectorAll('.wbhcartitem').forEach(el => {
          el.textContent = cartData.item_count;
        });
      }).catch(() => {});

      // Déclencher le popup cart-notification natif du thème
      const cartNotif = document.querySelector('cart-notification');
      if (cartNotif && typeof cartNotif.renderContents === 'function') {
        cartNotif.renderContents(parsedState);
      } else {
        this.cartToast();
      }

      btn.classList.remove('ct-loading');
      if (textEl) textEl.textContent = 'Ajouté !';
      setTimeout(() => {
        if (textEl) textEl.textContent = originalText;
        btn.disabled = false;
      }, 2500);

    } catch (err) {
      btn.classList.remove('ct-loading');
      if (textEl) textEl.textContent = originalText;
      btn.disabled = false;
      this.cartToast();
    }
  },

  cartToast() {
    let el = document.getElementById('ct-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ct-cart-toast';
      el.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(16px);background:#1a1a2e;color:#fff;padding:13px 20px;border-radius:10px;font-size:14px;font-weight:600;z-index:9999;opacity:0;transition:opacity .25s,transform .25s;pointer-events:auto;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,.3);display:flex;align-items:center;gap:14px;';
      el.innerHTML = '<span>Produit ajouté au panier</span><a href="/cart" style="background:#0090e3;color:#fff;padding:7px 14px;border-radius:7px;text-decoration:none;font-weight:700;font-size:13px;">Voir le panier</a>';
      document.body.appendChild(el);
    }
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(16px)';
    }, 4000);
  },

  renderPage() {
    const grid = document.getElementById('ct-wishlist-grid');
    const empty = document.getElementById('ct-wishlist-empty');
    if (!grid) return;
    const items = this.get();
    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.innerHTML = items.map(p => `
      <div class="ct-wish-card" data-id="${p.id}">
        <a href="${p.url}" class="ct-wish-card__img-wrap">
          ${p.image
            ? `<img src="${p.image}" alt="${p.title}" loading="lazy">`
            : `<div class="ct-wish-card__no-img"></div>`}
        </a>
        <div class="ct-wish-card__body">
          ${p.vendor ? `<p class="ct-wish-card__vendor">${p.vendor}</p>` : ''}
          <a href="${p.url}" class="ct-wish-card__title">${p.title}</a>
          <p class="ct-wish-card__price">${this.formatMoney(p.price)}</p>
          <div class="ct-wish-card__actions">
            <button
              class="ct-wish-card__btn ct-wish-card__btn--cart"
              data-add-variant="${p.variant_id || ''}"
              data-add-url="${p.url}"
              type="button"
            ><svg class="ct-pf-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" stroke-opacity=".25"/><path d="M12 2a10 10 0 0 1 10 10" stroke-opacity="1"/></svg><span class="ct-pf-btn-text">Ajouter au panier</span></button>
            <button class="ct-wish-card__btn ct-wish-card__btn--remove" data-remove="${p.id}" type="button">
              Retirer
            </button>
          </div>
        </div>
      </div>
    `).join('');
  },

  init() {
    this.syncAll();

    if (document.querySelector('.ct-wishlist-page')) {
      this.renderPage();
    }

    document.addEventListener('click', e => {
      // Heart toggle
      const wishBtn = e.target.closest('[data-wishlist-id]');
      if (wishBtn) {
        e.preventDefault();
        this.toggle({
          id:         parseInt(wishBtn.dataset.wishlistId),
          title:      wishBtn.dataset.wishlistTitle || '',
          price:      parseInt(wishBtn.dataset.wishlistPrice || '0'),
          image:      wishBtn.dataset.wishlistImage || '',
          url:        wishBtn.dataset.wishlistUrl || '/',
          vendor:     wishBtn.dataset.wishlistVendor || '',
          variant_id: wishBtn.dataset.wishlistVariant || ''
        });
        return;
      }

      // Add to cart from wishlist page
      const addBtn = e.target.closest('[data-add-variant]');
      if (addBtn) {
        e.preventDefault();
        const variantId = addBtn.dataset.addVariant;
        const productUrl = addBtn.dataset.addUrl;
        this.addToCart(variantId, productUrl, addBtn);
        return;
      }

      // Remove from wishlist page
      const removeBtn = e.target.closest('[data-remove]');
      if (removeBtn) {
        this.remove(parseInt(removeBtn.dataset.remove));
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => Wishlist.init());
